import { HMDAExportType } from './HmdaExportType';

export const HMDAExportTypeOptions = [
    {
        id: HMDAExportType.TextPipeDelimited,
        name: 'Filing Submission',
    },
    {
        id: HMDAExportType.Excel,
        name: 'Excel',
    },
    {
        id: HMDAExportType.ExcelTransposed,
        name: 'Excel (Transposed)',
    },
];
